import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: 'callback',
    loadComponent: () =>
      import('./pages/payment-callback/payment-callback.component').then(
        (m) => m.PaymentCallbackComponent,
      ),
  },
  {
    path: 'thank-you',
    loadComponent: () =>
      import('./pages/thank-you/thank-you.component').then(
        (m) => m.ThankYouComponent,
      ),
  },
  {
    path: 'payment-failed',
    loadComponent: () =>
      import('./pages/payment-failed/payment-failed.component').then(
        (m) => m.PaymentFailedComponent,
      ),
  },
  {
    path: 'transactions/:transactionId/payments/:paymentId/cancelled',
    loadComponent: () =>
      import('./pages/wallet-payment-result/wallet-payment-result.component').then(
        (m) => m.WalletPaymentResultComponent,
      ),
    data: { resultType: 'cancelled' },
  },
  {
    path: 'transactions/:transactionId/payments/:paymentId/declined',
    loadComponent: () =>
      import('./pages/wallet-payment-result/wallet-payment-result.component').then(
        (m) => m.WalletPaymentResultComponent,
      ),
    data: { resultType: 'declined' },
  },
  {
    path: 'transactions/:id',
    loadComponent: () =>
      import('./pages/transaction-details/transaction-details.component').then(
        (m) => m.TransactionDetailsComponent,
      ),
  },
  {
    path: 'merchants/:merchantId/branches/:branchId',
    loadComponent: () =>
      import('./pages/merchant-branch/merchant-branch.component').then(
        (m) => m.MerchantBranchComponent,
      ),
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('./features/orders/orders.route').then((m) => m.routes),
  },
  {
    path: '',
    redirectTo: 'orders',
    pathMatch: 'full',
  },
];
